import React from 'react';
import { Link } from 'react-router-dom';
import Typography from '../../sharedComponents/Typography/Typography';
import { i18nformatDateRangeLong } from '../../utils/i18n';
import { useActions } from '../../store/hooks';
import { TripListComponentProps } from './TripListComponent.types';
import styles from './trip-list-component.module.scss';
import { Spending } from '../../sharedComponents/assets/svg-tsx/icons';
import NeonGrassOverlayIcon from '../../sharedComponents/NeonGrassOverlayIcon/NeonGrassOverlayIcon';

const TripListComponent: React.FunctionComponent<TripListComponentProps> = ({
  // logoUri,
  location,
  hasOpenClaim,
  start,
  end,
  slug,
  id,
}) => {
  const dispatch = useActions();
  const clickHandler = (): void => {
    dispatch.setSelectedPolicyBundle(id);
  };

  return (
    <Link to={`/trips/${slug}`}>
      <button className={styles.container} onClick={clickHandler}>
        <div className={styles.detailsPositionWrapper}>
          <Typography variant="body-2" truncate>
            {location}
          </Typography>
          <Typography variant="body-2">
            {i18nformatDateRangeLong(start, end)}
          </Typography>
        </div>
        <div className={styles.payoutIndicator}>
          {hasOpenClaim && <NeonGrassOverlayIcon svg={<Spending />} />}
        </div>
      </button>
    </Link>
  );
};

export default TripListComponent;
